'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module', {
    url: '/module/:moduleId?expandedLessonId',
    reloadOnSearch: false,
    templateUrl: '/app/states/module/module.html',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow();
      },
      module: function (flow, Api, $stateParams) {
        return Api.module($stateParams.moduleId);
      }
    },
    controller: function ($scope, $stateParams, module, instance, Api, rmMacroService, $state, $http, $window, $viewport, rmGuide) {
      var guideId = 'lessonScreen';
      var guide =  _.find($scope.instance.guides, { id: guideId });
      var wasShownToUser = _.find($scope.user.meta.instance.guides, { id: guideId});
      $scope.introductionGuide = !wasShownToUser && (guide && guide.enabled) ? _.cloneDeep(guide) : false;
      $scope.showTutorial = !$scope.introductionGuide && _.get(instance, 'tutorial.enabled', false);
      $scope.isTutorialViewed = function (id) {
        return rmGuide.isViewed(id);
      };
      $scope.onNotificationDismiss = function () {
        rmGuide.markViewed($scope.module.tutorial.id);
      };
      $scope.onGuideExit = function () {
        return $http.post('/api/v1/me/guides/' + guideId).then(Api.me);
      };
      $scope.onGuideCompleted = function () {
        $window.scrollTo(0, 0);
        $scope.onGuideExit();
        $scope.showTutorial = _.get(instance, 'tutorial.enabled', false);
      };

      $scope.module = module;
      rmMacroService.set('module', module);

      Api.track('module.introduction', 'pass');

      $scope.expandedLessonId = $stateParams.expandedLessonId;

      $scope.$watch('$viewport.isMobile', function (isMobile) {
        var cols = isMobile ? 1 : 3;
        $scope.chunks = _([].concat(module.quizzes.pre, module.lessons, module.quizzes.post))
          .compact()
          .filter()
          .groupBy(function (element, index) { return index % cols; }).toArray().value();
      });

      $scope.carousel = function (lesson) {
        if (!$viewport.isMobile) { return; }
        $state.go('.carousel', { lessonId: lesson._id });
      };
    }
  });

});
